import React, { useEffect, useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { capitalize } from "lodash";
import parse from "html-react-parser";
import { getProductDetail } from "../../../actions/dashboardAction";
import DateFormat from "../../common/dateFormat";
import { imageUrl, numberFormat } from "../../../actions/miscAction";
import Skeleton from "react-loading-skeleton";

const pdffileImg = `${process.env.GATSBY_IMAGE_URL}pdf-file.svg`;
const docfileImg = `${process.env.GATSBY_IMAGE_URL}doc-file.svg`;
const pdfIcon = imageUrl("pdf-doc-img.svg");
const editIcon = imageUrl("edit-new-i.svg");

const ViewListing = (props) => {
  const [detail, setDetail] = useState({});
  const [loadingDetail, setLoadingDetail] = useState(true);

  useEffect(() => {
    if (props?.show && props?.selectedQuestion?.id) {
      setLoadingDetail(true);
      getProductDetail(props?.selectedQuestion?.id, (res) => {
        setLoadingDetail(false);
        if (res.status === 200) {
          setDetail(res.data);
        }
      });
    }
  }, [props?.show]);

  return (
    <Offcanvas
      className={`offcanvas offcanvas-dashboard ${
        props?.isLeftOpen ? "offcanvas-start" : "offcanvas-end"
      }  chat-screen`}
      backdropClassName={`modal-backdrop view-backdrop`}
      placement={props?.isLeftOpen ? "start" : "end"}
      show={props?.show}
      onHide={() => props?.onHide()}
    >
      <Offcanvas.Header className="offcanvas-header border-bottom">
        <h5 id="offcanvasRightLabel">{`${props?.selectedQuestion?.description}`}</h5>
        <button
          type="button"
          class="btn-close text-reset"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={() => props?.onHide()}
        ></button>
      </Offcanvas.Header>
      <Offcanvas.Body class="offcanvas-body p-0">
        <div class="offcanvas-view-listing">
          {loadingDetail ? (
            <div class="ovl-content-outer">
              <div class="ovl-content d-flex flex-wrap">
                <div class="ovl-box w-100">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box w-100 ">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box w-100">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
                <div class="ovl-box">
                  <Skeleton height={"30px"} />
                  <Skeleton height={"30px"} />
                </div>
              </div>
            </div>
          ) : (
            <>
              <div class="ovl-content-outer">
                <h5>Product Information </h5>
                <div class="ovl-content d-flex flex-wrap">
                  <div class="ovl-box w-100">
                    <h6>Title</h6>
                    <p>{props?.selectedQuestion?.description}</p>
                  </div>
                  <div class="ovl-box w-100 ">
                    <h6>Description</h6>
                    <p className="seller-description-scroll sustainability-product-detail-fix dot-list-fix dot-list customized-bullet table-seller-detail">
                      {detail?.detail?.details ? parse(detail?.detail?.details) : "N/A"}
                    </p>
                  </div>
                  <div class="ovl-box">
                    <h6>Posted On</h6>
                    <p>
                      {props?.selectedQuestion?.date_posted ? (
                        <DateFormat date={props?.selectedQuestion?.date_posted} />
                      ) : (
                        "N/A"
                      )}
                    </p>
                  </div>
                  <div class="ovl-box">
                    <h6>Quantity</h6>
                    <p>{props?.selectedQuestion?.quantity || "N/A"}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Status</h6>
                    <p>{capitalize(props?.selectedQuestion?.status_name)}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Category</h6>
                    <p>{props?.selectedQuestion?.cat_description}</p>
                  </div>
                  <div class="ovl-box w-100">
                    <h6>Condition</h6>
                    {detail?.conditionType ? <p>{detail?.conditionType}</p> : ""}
                    {detail?.condition ? <p>{detail?.condition}</p> : "N/A"}
                  </div>
                  <div class="ovl-box">
                    <h6>Carbon Footprint</h6>
                    <p>
                      {props?.selectedQuestion?.co2e_total ? numberFormat(props?.selectedQuestion?.co2e_total) : "N/A"}
                    </p>
                  </div>
                  <div class="ovl-box">
                    <h6>Business Unit</h6>
                    <p>{props?.selectedQuestion?.project_name}</p>
                  </div>
                </div>
              </div>
              <div class="ovl-content-outer">
                <h5>Product Location </h5>
                <div class="ovl-content d-flex flex-wrap">
                  {detail?.tarderName && (
                    <div class="ovl-box w-100">
                      <h6>{detail?.tarderName || ""}</h6>
                    </div>
                  )}

                  <div class="ovl-box">
                    <h6>Email</h6>
                    <p>{detail?.tarderEmail || "N/A"}</p>
                  </div>
                  <div class="ovl-box">
                    <h6>Address</h6>
                    <p>{props?.selectedQuestion?.auction_location || "N/A"}</p>
                  </div>
                </div>
              </div>
              <div class="ovl-content-outer">
                <h5>Qty & Pricing</h5>
                <div class="ovl-content d-flex flex-wrap">
                  <div class="ovl-box">
                    <h6>Wholesale Value</h6>
                    <p>
                      {props?.selectedQuestion?.wholesale_value
                        ? "$" + numberFormat(props?.selectedQuestion?.wholesale_value)
                        : "N/A"}
                    </p>
                  </div>
                  <div class="ovl-box">
                    <h6>Retail Value</h6>
                    <p>
                      {props?.selectedQuestion?.retail_value
                        ? "$" + numberFormat(props?.selectedQuestion?.retail_value)
                        : "N/A"}
                    </p>
                  </div>
                  <div class="ovl-box">
                    <h6>Claim Price</h6>
                    <p>
                      {props?.selectedQuestion?.claim_value
                        ? "$" + numberFormat(props?.selectedQuestion?.claim_value)
                        : "N/A"}
                    </p>
                  </div>
                  <div class="ovl-box">
                    <h6>Reserve Price</h6>
                    <p>{props?.selectedQuestion?.reserve_value ? props?.selectedQuestion?.reserve_value : "N/A"}</p>
                  </div>
                </div>
              </div>
              {detail?.pics?.length > 0 && (
                <div class="ovl-content-outer">
                  <h5>Images</h5>
                  <div class="uploaded-image-list d-flex flex-wrap">
                    {detail?.pics?.map((ep) => (
                      <div class="uploaded-image-item">
                        <div class="uploaded-image-box">
                          <div class="uib-img position-relative">
                            {ep?.s_path.substring(0, 5) === "https" ? (
                              <img src={`${ep.s_path}${ep.filename}_lp.${ep.suffix}`} alt={ep?.filename} />
                            ) : (
                              <img
                                src={`${process.env.GATSBY_MEDIA_URL}${ep?.s_path}${ep?.filename}_lp.${ep?.suffix}`}
                                alt={ep?.filename}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {detail?.documents?.length > 0 && (
                <div class="ovl-content-outer">
                  <h5>Documents</h5>
                  <div class="uploaded-file-list">
                    {detail &&
                      detail.documents &&
                      detail.documents.length > 0 &&
                      detail.documents.map((f, i) => (
                        <div
                          class="uploaded-file-item"
                          onClick={() => window.open(process.env.GATSBY_MEDIA_URL + f.filename)}
                        >
                          <div class="uploaded-file-box d-flex justify-content-between">
                            <div class="ufb-content d-flex flex-grow-1">
                              <div class="ufb-icon d-flex align-items-center">
                                <img
                                  class="ufb-icon"
                                  style={{ width: "24px", height: "24px" }}
                                  src={pdfIcon}
                                  alt="docfileImg"
                                />
                              </div>
                              <div
                                class="ufb-file-name align-self-center cursor-pointer"
                                onClick={() =>
                                  window.open(
                                    f?.s_path.substring(0, 5) === "https"
                                      ? `${f?.filename}`
                                      : `https://${process.env.GATSBY_APP_S3_BUCKET}${f?.filename}`,
                                  )
                                }
                              >
                                {f.name}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ViewListing;
